import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { OrderOccasion } from '@app/models/order-occasion';
import { Site } from '@app/models/site';

@Component({
    selector: 'app-home-page-collection-tab',
    templateUrl: './home-page-collection-tab.component.html',
    standalone: false
})
export class HomePageCollectionTabComponent implements OnChanges {
  @Input() public noStoresFound: boolean;
  public allCollectionSites: Site[] = [];
  public allDeliverySites: Site[] = [];
  public showNoSitesError: boolean;
  public supportedSites: Site[] = [];

  @Output('onSelection') private _onSelection: EventEmitter<Site>;
  @Input('sites') private _sites: Site[];

  constructor() {
    this._onSelection = new EventEmitter<Site>();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes._sites) {
      return;
    }

    this.showNoSitesError = this._sites.length === 0;
    this.supportedSites = this._sites
        .filter((x: Site) => x.OccasionsSupported?.includes(OrderOccasion.Collection))
        .sort((a: Site, b: Site) => a.Name.localeCompare(b.Name));
  }

  /**
  * returns the phone number with the HTML tel marker to allow it function as a clickable phone number
  * @param number - the phone number
  */
  public getPhoneNumber(number: string): string {
    return `tel:${number?.replace(/\s/g, '')}`;
  }

  /**
   * outputs the selected site.
   * @param site
   */
  public setSelectedStore(site: Site): void {
    this._onSelection.emit(site);
  }
}
